import { LaFilterPanelState } from '../types';

export function laFilterPanelToHash(
  fpState: LaFilterPanelState,
  limit: number
): string {
  const keyCount = Object.keys(fpState).length;
  if (keyCount !== 5) {
    throw Error(
      'Developer, laFilterPanelToHash(), the filter panel has expanded from having just four properties, update this hashing function to include the new properties'
    );
  }

  const nodes = fpState.nodesValue
    .sort()
    .map((e) => {
      return e.toLowerCase();
    })
    .join('');

  return `la-fp-hash-${limit}-${nodes}-${fpState.maxIpConnections}-${fpState.idType}-${fpState.value}-${fpState.hop}`
    .toLowerCase()
    .trim();
}
